import AppContainer from "./AppContainer";

/**
 * Full-page buyer loader. CSS oval — no react-loader-spinner (defaultProps warn). `message`, when
 * given, is shown under it (e.g. while leaving for the payment page).
 */
const LoaderComponent = ({ message }) => (
  <AppContainer>
    <div
      className="fixed inset-0 z-[95] flex flex-col items-center justify-center gap-4 px-6"
      role="status"
      aria-label={message || "Loading"}
    >
      <span
        className="inline-block h-10 w-10 animate-spin rounded-full border-[3px] border-[#ccc] border-t-transparent"
        aria-hidden
      />
      {message ? (
        <p className="text-center font-montserrat text-[14px] font-medium text-checkoutText">
          {message}
        </p>
      ) : null}
    </div>
  </AppContainer>
);

export default LoaderComponent;
